module.exports = __webpack_public_path__ + "img/AL801-2.b52679f3.jpg";